module.exports = __webpack_public_path__ + "static/media/laptop.fa8013cd.png";